export default __webpack_public_path__ + "6cefe71966b432599581692d664b11ba.png";